import request from '@/libs/request'

// 仓库人员排班 列表
export function warehouseDutyListApi (data) {
  return request({
    url: `warehouse/warehouseDuty`,
    method: 'get',
    params: data
  })
}

// 仓库人员排班 详情
export function warehouseDutyDetailApi (id) {
  return request({
    url: `warehouse/warehouseDuty/` + id,
    method: 'get'
  })
}


// 仓库人员排班 编辑/添加
export function warehouseDutySaveApi (data) {
  return request({
    url: `warehouse/warehouseDuty`,
    method: 'post',
    data: data
  })
}

// 仓库人员排班 删除
export function warehouseDutyDelApi (id) {
  return request({
    url: `warehouse/warehouseDuty/` + id,
    method: 'delete'
  })
}

